/*
 * Customer-dashboard (custlo) forms: turn each field's <label> text into the
 * field's placeholder, so the label can be hidden via CSS while the field still
 * shows what it is.
 *
 * Markup (rendered by the app inside the theme layout):
 *   <div class="custlo-t1-form-group">
 *     <label class="custlo-t1-form-label" for="...">First name</label>
 *     <input class="custlo-t1-form-input" ...>            // or <select>/<textarea>
 *   </div>
 *
 * Behavior:
 *   - <input>/<textarea>: set placeholder to the label text (unless one is already set).
 *   - <select>: set the first empty/placeholder option's text to the label so it
 *     reads as a prompt (selects can't take a placeholder attribute).
 *   - Runs on load and re-applies when the app re-renders the form (MutationObserver).
 */
(function () {
  var GROUP = '.custlo-t1-form-group';
  var LABEL = '.custlo-t1-form-label';
  var FIELD = '.custlo-t1-form-input, input, select, textarea';

  function labelText(label) {
    // Strip a trailing required marker like "*" and collapse whitespace.
    return (label.textContent || '').replace(/\s*\*\s*$/, '').trim();
  }

  function applyToSelect(select, text) {
    // Use the placeholder-ish first option (empty value, or the "---" the app emits).
    var first = select.options && select.options[0];
    if (!first) return;
    var isPlaceholderOption =
      first.value === '' || first.value === '---' || first.disabled;
    if (isPlaceholderOption) {
      first.textContent = text;
    }
  }

  function apply(root) {
    (root || document).querySelectorAll(GROUP).forEach(function (group) {
      var label = group.querySelector(LABEL);
      if (!label) return;
      var text = labelText(label);
      if (!text) return;

      var field = group.querySelector(FIELD);
      if (!field) return;

      if (field.tagName === 'SELECT') {
        applyToSelect(field, text);
      } else if (!field.getAttribute('placeholder')) {
        field.setAttribute('placeholder', text);
      }
    });
  }

  function init() {
    apply();
    // The app re-renders forms (open Add/Edit address, switch tabs). Re-apply,
    // debounced, whenever new nodes appear.
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { apply(); }, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
